// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__uIKb7","modal":"Modal_modal__4Gx48","header":"Modal_header__v9XwI","body":"Modal_body__aeTJB","footer":"Modal_footer__-24-i","close":"Modal_close__FgpmB"};